import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  Project,
  ProjectFilters,
} from '../../admin/models/project.model';

export interface ProjectCalculation {
  projectId: string;
  projectName: string;
  co2Kg: number;
  pricePerTonne: number;
  amount: number;
}

@Injectable({
  providedIn: 'root',
})
export class ProjectPublicService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/projects`;

  /**
   * List active projects (public endpoint)
   */
  listProjects(filters?: ProjectFilters): Observable<{ data: Project[] }> {
    let params = new HttpParams();

    if (filters) {
      if (filters.q) params = params.set('q', filters.q);
      if (filters.projectType) params = params.set('projectType', filters.projectType);
      if (filters.region) params = params.set('region', filters.region);
      if (filters.certificationStandard) params = params.set('certificationStandard', filters.certificationStandard);
      if (filters.isCertifiedOffset !== undefined) params = params.set('isCertifiedOffset', filters.isCertifiedOffset.toString());
    }

    return this.http.get<{ data: Project[] }>(this.baseUrl, { params });
  }

  /**
   * Get default project
   */
  getDefaultProject(): Observable<{ data: Project }> {
    return this.http.get<{ data: Project }>(`${this.baseUrl}/default`);
  }

  /**
   * Get project by slug
   */
  getProjectBySlug(slug: string): Observable<{ data: Project }> {
    return this.http.get<{ data: Project }>(`${this.baseUrl}/${slug}`);
  }

  /**
   * Calculate contribution for a project
   */
  calculateContribution(projectId: string, co2Kg: number): Observable<{ data: ProjectCalculation }> {
    return this.http.post<{ data: ProjectCalculation }>(
      `${this.baseUrl}/${projectId}/calculate`,
      { co2Kg }
    );
  }
}
